module.exports = __webpack_public_path__ + "img/gorou.287f6a2c.webp";